export const APP_NAME = process.env.REACT_APP_APP_NAME || 'SmartReader';

// Polling interval in milliseconds for device status updates.
// Can be overridden via the REACT_APP_DEVICE_STATUS_POLL_INTERVAL_MS env variable.
export const DEVICE_STATUS_POLL_INTERVAL_MS =
  parseInt(process.env.REACT_APP_DEVICE_STATUS_POLL_INTERVAL_MS || '30000', 10);

// Paths for which the main menu should be hidden in the UI.
export const HIDDEN_MENU_PATHS = (process.env.REACT_APP_HIDDEN_MENU_PATHS || '')
  .split(',')
  .map((path) => path.trim())
  .filter(Boolean);

// Feature flag controlling the new devices list view. Defaults to disabled.
// Set REACT_APP_LIST_VIEW_ENABLED=true to enable the new list view.
export const LIST_VIEW_ENABLED =
  (process.env.REACT_APP_LIST_VIEW_ENABLED || 'false') === 'true';

